import React, { useState, useEffect } from "react";
import CustomTabs from "../ui/CustomTabs";
import { useParams, useNavigate } from "react-router-dom";
import GuideContentRenderer from "./guideContentRenderer";

const GuideRenderer = ({ url, guideData }) => {
  const [activeTab, setActiveTab] = useState(guideData.sections?.[0]?.id);
  const { sectionId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (sectionId) {
      setActiveTab(sectionId);
    }
  }, [sectionId]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/wiki/${url}/${tabKey}`);
  };

  const sectionTabs = (guideData.sections || []).map((section) => ({
    key: section.id,
    label: section.title,
    component: <GuideContentRenderer content={section.content || []} />,
  }));

  return (
    <div className="panel-style">
      <h1 className="wiki-main-title">{guideData.title}</h1>
      <CustomTabs tabs={sectionTabs} activeTab={activeTab} onTabChange={handleTabChange} />
    </div>
  );
};

export default GuideRenderer;
